export default "__VITE_ASSET__DwP8IjgR__"